import { Provider } from "@angular/core";
import { PORTAL_ANY_AUTHORIZING_ROLES_TOKEN } from "../../constants";
import { AuthService } from "./auth.service";
import { UserAuthorizedService } from "./user-authorized.service";

export function providePortalAuthServices(atLeastOneOfRolesToAuthorize?: string[]): Provider[] {
  const providers: Provider[] = [];
  if (atLeastOneOfRolesToAuthorize && atLeastOneOfRolesToAuthorize.length > 0) {
    providers.push({
      provide: PORTAL_ANY_AUTHORIZING_ROLES_TOKEN,
      useValue: atLeastOneOfRolesToAuthorize,
    });
  }
  providers.push(AuthService);
  providers.push(UserAuthorizedService);
  return providers;
}
